module.exports = __webpack_public_path__ + "img/shuju_active.919ac47b.png";